<template>
    <div class="home container-fluid py-2">
        <b-card class="mb-4">
            <b-form @submit.prevent="search" class="mb-3">
                <b-form-group label="Search:">
                    <b-form-input
                        v-model="filter.search"
                        placeholder="Search username, awsAccountId, awsAccountName, awsPayerAccountName"
                    ></b-form-input>
                </b-form-group>
                <b-form-group label="Created from date:">
                    <b-form-datepicker
                        v-model="filter.from"
                        today-button
                        reset-button
                        close-button
                        value-as-date
                    ></b-form-datepicker>
                </b-form-group>
                <b-form-group label="Created to date:">
                    <b-form-datepicker
                        v-model="filter.to"
                        today-button
                        reset-button
                        close-button
                        value-as-date
                    ></b-form-datepicker>
                </b-form-group>
                <b-form-group label="Status" class="mb-4">
                    <b-form-checkbox-group
                        v-model="filter.status"
                        :options="statusOptions"
                    >
                    </b-form-checkbox-group>
                </b-form-group>
                <div class="d-flex align-items-center">
                    <b-button type="submit" class="mr-3 w-25" variant="primary">
                        Search
                    </b-button>
                    <b-form-checkbox v-model="filter.isActive">
                        Only show active
                    </b-form-checkbox>
                </div>
            </b-form>
        </b-card>

        <b-button @click="onClickAdd" class="px-5 mb-3" variant="primary"
            >Add</b-button
        >
        <b-table :fields="fields" :items="items">
            <template #cell(isActive)="data">
                <b-badge :variant="data.value ? 'info' : 'secondary'">{{
                    data.value
                }}</b-badge>
            </template>
            <template #cell(action)="data">
                <b-button
                    @click="onClickInvoice(data)"
                    class="mr-1 mb-1"
                    variant="primary"
                    >Invoice</b-button
                >
                <b-dropdown
                    id="dropdown-more"
                    text="More"
                    variant="primary"
                    class="mb-1"
                >
                    <b-dropdown-item @click="onClickSwitch(data)"
                        >Switch</b-dropdown-item
                    >
                    <b-dropdown-item @click="onClickEdit(data)"
                        >Edit</b-dropdown-item
                    >
                    <b-dropdown-item @click="onClickDetail(data)"
                        >Detail</b-dropdown-item
                    >
                    <b-dropdown-item @click="toggleActive(data.item)">{{
                        data.item.isActive ? 'Deactivate' : 'Activate'
                    }}</b-dropdown-item>

                    <b-dropdown-item @click="onClickBalanceRecord(data)"
                        >Balance Records</b-dropdown-item
                    >
                </b-dropdown>
            </template>
        </b-table>
        <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            @change="onChangePage"
        ></b-pagination>
        <AddOrEditModal
            v-model="modalAddOrEdit"
            :current-data="currentData"
            @onDone="fetchData"
        ></AddOrEditModal>
        <DetailModal
            v-model="modalDetail"
            :aws-account-uuid="currentData?.id"
        ></DetailModal>
        <InvoiceModal
            v-model="modalInvoice"
            :aws-account-uuid="currentData?.id"
        ></InvoiceModal>
    </div>
</template>

<script>
import {
    changeAwsAccountStatus,
    getAwsAccounts,
    getAwsAccountTempCredential,
} from '@/services/aws.service';
import * as moment from 'moment';
import AddOrEditModal from '@/views/Modals/AddOrEditModal/AddOrEditModal.vue';
import DetailModal from '@/views/Modals/DetailModal/DetailModal.vue';
import InvoiceModal from '@/views/Modals/InvoiceModal/InvoiceModal.vue';

export default {
    name: 'HomeView',
    components: { DetailModal, AddOrEditModal, InvoiceModal },
    data() {
        return {
            modalDetail: false,
            modalAddOrEdit: false,
            modalInvoice: false,
            currentData: null,
            filter: {
                search: '',
                from: '',
                to: '',
                isActive: false,
                status: [],
            },
            statusOptions: [
                { text: 'SYNCHRONIZING', value: 'SYNCHRONIZING' },
                { text: 'SYNCHRONIZED', value: 'SYNCHRONIZED' },
                { text: 'WRONG_ACCOUNT_ID', value: 'WRONG_ACCOUNT_ID' },
            ],
            items: [],
            perPage: 10,
            currentPage: 1,
            total: 0,
            fields: [
                {
                    key: 'username',
                    label: 'username',
                },
                {
                    key: 'awsPayerAccountName',
                    label: 'awsPayerAccountName',
                },
                {
                    key: 'awsAccountId',
                    label: 'awsAccountId',
                },
                {
                    key: 'awsAccountName',
                    label: 'awsAccountName',
                },
                {
                    key: 'status',
                    label: 'status',
                },
                {
                    key: 'isActive',
                    label: 'isActive',
                },
                {
                    key: 'action',
                    label: 'actions',
                },
            ],
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            const query = {
                search: this.filter.search || undefined,
                from: this.filter.from
                    ? moment(this.filter.from).startOf('day').toISOString()
                    : undefined,
                to: this.filter.to
                    ? moment(this.filter.to).endOf('day').toISOString()
                    : undefined,
                status:
                    this.filter.status?.length > 0
                        ? this.filter.status.join(',')
                        : undefined,
                isActive: this.filter.isActive || undefined,
                page: this.currentPage,
                limit: this.perPage,
            };
            getAwsAccounts(query).then(({ data }) => {
                const { accounts, paginate } = data;
                this.items = accounts;
                this.perPage = paginate.perPage;
                this.currentPage = paginate.currentPage;
                this.total = paginate.total;
            });
        },
        search() {
            this.fetchData();
        },
        onChangePage(val) {
            this.currentPage = val;
            this.fetchData();
        },
        onClickEdit(data) {
            this.currentData = data.item;
            this.modalAddOrEdit = true;
        },
        onClickInvoice(data) {
            this.currentData = data.item;
            this.modalInvoice = true;
        },
        onClickSwitch(data) {
            getAwsAccountTempCredential(data.item.id).then(({ data }) => {
                window.open(data, '_blank');
            });
        },
        onClickAdd() {
            this.currentData = null;
            this.modalAddOrEdit = true;
        },
        onClickDetail(data) {
            this.currentData = data.item;
            this.modalDetail = true;
        },
        toggleActive(item) {
            this.$bvModal
                .msgBoxConfirm('Are you sure?', {
                    title: 'Please Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'YES',
                    cancelTitle: 'NO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((isYes) => {
                    if (isYes) {
                        changeAwsAccountStatus(item.id, !item.isActive).then(
                            () => {
                                this.$bvToast.toast(`Update success!`, {
                                    title: 'Success',
                                    autoHideDelay: 5000,
                                    appendToast: true,
                                    variant: 'success',
                                    solid: false,
                                    toaster: 'b-toaster-top-center',
                                });
                                this.fetchData();
                            }
                        );
                    }
                });
        },
        onClickBalanceRecord(data) {
            this.$router.push({
                name: 'balance-records',
                params: {
                    accountId: data.item.id,
                },
            });
        },
    },
};
</script>
